<template>
  <generic-modal
    :title="$t('availability')"
    ref="generic_modal"
    :is_wide="true"
  >
    <div class="is-full-height">
      <full-calendar
        :options="calendarOptions"
        ref="full_calendar"
      ></full-calendar>
    </div>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-check"></i>
        </span>
        <span>{{ $t("ok") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import FullCalendar from "@fullcalendar/vue3";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import moment from "moment";
import { v4 } from "uuid";

export default {
  name: "AvailabilityModal",
  components: { GenericModal, FullCalendar },
  data() {
    let v = this;
    return {
      meta: {},
      error: "",
      events: [],
      calendarOptions: {
        locale: v.$i18n.locale,
        editable: true,
        nowIndicator: true,
        // now: true,
        buttonText: {
          today: v.$t("today"),
          month: v.$t("month"),
          week: v.$t("week"),
          day: v.$t("day"),
        },
        headerToolbar: {
          left: "",
          center: "",
          right: "",
        },
        plugins: [dayGridPlugin, interactionPlugin, timeGridPlugin],
        initialView: "timeGridWeek",
        dateClick: function (info) {
          //console.log("dateClick", info);
          // add event to calendar
          v.calendarOptions.events.push({
            id: v4(),
            start: info.dateStr,
            end: moment(info.dateStr).add(1, "hour").format(),
          });
          // console.log(v.$refs.full_calendar);
        },
        eventChange: function (info) {
          // console.log("eventChange", info.event._def.publicId);
          let event = v.calendarOptions.events.find(
            (e) => e.id === info.event._def.publicId
          );
          event.start = info.event.start;
          event.end = info.event.end;
        },
        events: [],
      },
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      return false;
      //return !v.meta.name;
    },
  },
  methods: {
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal(settings) {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.show_modal();
      if (settings.availability) {
        let evnts = settings.availability.map((e) => {
          let dte_start = moment().isoWeekday(Number(e.iso_day_of_week));
          let dte_end = moment().isoWeekday(Number(e.iso_day_of_week));
          if (dte_start.format("E") == "7") {
            dte_start.add(-1, "week");
            dte_end.add(-1, "week");
          }
          let start = dte_start
            .set({
              hour: e.from.split(":")[0],
              minute: e.from.split(":")[1],
            })
            //.add(-1, "week")
            .toISOString();
          let end = dte_end
            .set({
              hour: e.to.split(":")[0],
              minute: e.to.split(":")[1],
            })
            //.add(-1, "week")
            .toISOString();

          return {
            id: v4(),
            start: start,
            end: end,
          };
        });
        // console.log("evnts", evnts);
        v.calendarOptions.events = evnts;
      }
    },
    // edit_modal(uuid) {
    //   let v = this;
    //   v.set_initial_state();

    //   get("/pilates_member/station", { uuid: uuid })
    //     .then((element) => {
    //       v.meta = element;
    //       v.$refs.generic_modal.show_modal();
    //     })
    //     .catch((error) => {
    //       v.error = generate_error_message_text(error);
    //     });
    // },
    save() {
      let v = this;
      let events = v.calendarOptions.events || [];
      events = events.map((e) => {
        return {
          iso_day_of_week: moment(e.start).format("E"),
          from: moment(e.start).format("HH:mm"),
          to: moment(e.end).format("HH:mm"),
        };
      });
      v.$emit("save", events);
      v.$refs.generic_modal.close_modal();
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        settings: {},
      };
      v.error = "";
      v.calendarOptions.events = [];
      // v.uuid = "";
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
